module.exports = __webpack_public_path__ + "img/manage_pre_logo.07a7c3ce.png";